import {DropdownNestedMenuProps} from './types'
import DropdownNestedMenuView from './DropdownNestedMenuView'
import React from 'react'

const DropdownNestedMenu = (props: DropdownNestedMenuProps) => <DropdownNestedMenuView {...props} />

export default DropdownNestedMenu
